<template>
  <div id='bd-register'>
    <el-main>
      <el-row v-if="firstStep">
        <el-col :span="7"><div class="grid-content"></div></el-col>
        <el-col :span="8">
          <el-form :model="emailForm" status-icon :rules="registerRoles" ref="emailForm" label-width="100px">
            <el-form-item label="邮箱" prop="email">
              <el-input type="email" placeholder="请输入邮箱" v-model="emailForm.email" clearable style="width: 300px;">
                <el-button slot="append" :loading="emailButtonCountingDown" @click="getEmailCode">{{ emailButtonText }}</el-button>
              </el-input>
            </el-form-item>
            <el-form-item label="验证码" prop="email_code">
              <el-input placeholder="请输入验证码" v-model="emailForm.email_code" auto-complete="off" clearable style="width: 300px;"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="routeLogin">登录</el-button>
              <el-button type="primary" @click="nextSecondStep">注册</el-button>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="7"><div class="grid-content"></div></el-col>
      </el-row>
    </el-main>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import * as https from '@/apis/http'
// const constants = require('@/util/constants')

export default {
  name: 'bd-register',
  data () {
    var validateEmail = (rule, value, callback) => {
      // 验证邮箱唯一性
      https.emailValidate(this.emailForm.email,
        response => {
          console.log(response)
          if (response.status_code === 200) {
            callback()
          } else {
            // 邮箱已经存在，提示用户重新填写
            callback(new Error('邮箱已经存在，请重新填写'))
          }
        }, error => {
          console.log(error)
        })
    }
    var validateEmailCode = (rule, value, callback) => {
      // 验证验证码的有效性
      if (parseInt(value) !== this.emailServerCode) {
        callback(new Error('验证码错误'))
      } else {
        callback()
      }
    }
    var validateSubDomain = (rule, value, callback) => {
      // 验证二级域名唯一性
      https.subDomainValidate(this.subDomainForm.sub_domain,
        response => {
          console.log(response)
          if (response.status_code === 200) {
            callback()
          } else {
            callback(new Error('已经存在，请重新填写'))
          }
        }, error => {
          console.log(error)
        })
    }
    var validatePassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.registerForm.rePassword !== '') {
          this.$refs.registerForm.validateField('rePassword')
        }
        callback()
      }
    }
    var validateRePassword = (rule, value, callback) => {
      if (value !== this.registerForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      // 是否登录中
      logining: false,
      // models
      emailForm: {
        email: '',
        email_code: ''
      },
      subDomainForm: {
        sub_domain: 'vip'
      },
      registerForm: {
        password: '',
        rePassword: ''
      },
      // 验证规则
      registerRoles: {
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'change' },
          { validator: validateEmail, trigger: 'blur' }
        ],
        email_code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { validator: validateEmailCode, trigger: 'change' }
        ],
        sub_domain: [
          { required: true, message: '请输入二级域名', trigger: 'blur' },
          { validator: validateSubDomain, trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 16, message: '长度在 6 到 16 个字符之间', trigger: 'blur' },
          { validator: validatePassword, trigger: 'blur' }
        ],
        rePassword: [
          { required: true, message: '请输入确认密码', trigger: 'blur' },
          { validator: validateRePassword, trigger: 'blur' }
        ]
      },
      // 邮箱验证码
      emailServerCode: 0,
      // 邮箱发送验证码button是否禁用
      emailButtonCountingDown: false,
      // 60秒倒计时
      emailCountDownTime: 0,
      // 验证邮箱
      firstStep: true,
      // 验证二级域名
      secondStep: false,
      // 验证密码
      thirdStep: false,
      // 显示企业号
      forthStep: false
    }
  },
  computed: {
    ...mapGetters([ 'mainHost' ]),
    emailButtonText () {
      // 邮箱验证码button文字
      return this.emailCountDownTime > 0 ? this.emailCountDownTime + 's后重新获取' : '获取验证码'
    }
  },
  watch: {
    emailCountDownTime (value) {
      if (this.value === 0) {
        this.emailButtonCountingDown = false
      }
    }
  },
  methods: {
    ...mapActions([
      'updatePassportToken'
    ]),
    // 获取验证码
    getEmailCode () {
      // 1. 首先验证输入框是否通过验证
      this.$refs['emailForm'].validateField('email', (error) => {
        console.log(error)
        if (!error) {
          // 2. 请求发送验证码
          https.getEmailCode(this.emailForm.email, response => {
            console.log(response)
            this.emailServerCode = response.data
            // 倒计时
            this.emailButtonCountingDown = true
            this.emailCountDownTime = 60
            this.emailTimer()
            // 提示
            this.$message({ message: '发送成功', type: 'success' })
          }, error => {
            console.log(error)
            this.$message.error('发送失败, 请重试: ' + error)
          })
        } else {
          return false
        }
      })
    },
    emailTimer () {
      // 倒计时
      if (this.emailCountDownTime > 0) {
        this.emailCountDownTime--
        setTimeout(this.emailTimer, 1000)
      }
    },
    nextSecondStep () {
      // 输入验证码，验证通过，这跳转到填写二级域名页面
      this.$refs['emailForm'].validate((valid) => {
        if (valid) {
          this.firstStep = false
          // this.secondStep = true
          this.thirdStep = true
        } else {
          return false
        }
      })
    },
    preFirstStep () {
      // 返回第一页email页面
      this.secondStep = false
      this.firstStep = true
    },
    nextThirdStep () {
      // 下翻到密码页面,输入二级域名，如果唯一，则跳转填写密码页面
      this.$refs['subDomainForm'].validate((valid) => {
        if (valid) {
          this.secondStep = false
          this.thirdStep = true
        } else {
          return false
        }
      })
    },
    preSecondStep () {
      // 上翻到subdomain页面
      this.thirdStep = false
      // this.secondStep = true
      this.firstStep = true
    },
    register () {
      // 首先验证form是否通过，然后调用注册接口
      this.$refs['registerForm'].validate((valid) => {
        if (valid) {
          this.logining = true
          https.register(this.emailForm.email.toLowerCase(), this.registerForm.password,
            response => {
              console.log('register success:', response)
              this.subDomainForm.sub_domain = response.data.subDomain
              this.$message({ message: '注册成功', type: 'success' })
              this.thirdStep = false
              this.forthStep = true
              // 自动登录
              // this.login()
              this.logining = false
            }, error => {
              console.log('register error:', error)
              this.logining = false
            })
        } else {
          return false
        }
      })
    },
    login () {
      // 登录，默认username === email
      https.login(this.emailForm.email.toLowerCase(), this.registerForm.password,
        response => {
          console.log('login success:', response)
          this.logining = false
          // 务必设置一下
          localStorage.access_token = response.access_token
          this.updatePassportToken(response)
          //
          this.$router.replace('/admin')
        }, error => {
          console.log('login error:', error)
          this.logining = false
        })
    },
    routeLogin () {
      // 跳转登录页面
      this.$router.replace('/login')
    }
  }

}
</script>

<style scoped>
#bd-register {
  margin-top: 100px;
}
.grid-content {
  min-height: 36px;
}
</style>
